import React from 'react';
import BaseChatMessage from './BaseChatMessage';

export default class ChatMessageSent extends BaseChatMessage {
  render() {
    return (
      <div className={'message out'} key={this.props.keyValue} style={{ textAlign: 'right' }}>
        <label>{this.props.message}</label>
      </div>
    );
  }
}
